import { useCallback, useEffect, useState } from 'react';
import _debounce from 'lodash/debounce';

export const useDebounce = <T>(value: T, delay: number) => {
	const [debouncedValue, setDebouncedValue] = useState<T>(value);

	const debouncedSet = useCallback(_debounce(setDebouncedValue, delay), [delay, setDebouncedValue]);

	useEffect(() => {
		debouncedSet(value);
	}, [value, debouncedSet]);

	return debouncedValue;
};
